var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 7.64258H3.33333C2.59695 7.64258 2 8.2647 2 9.03212V13.8955C2 14.6629 2.59695 15.285 3.33333 15.285H12.6667C13.403 15.285 14 14.6629 14 13.8955V9.03212C14 8.2647 13.403 7.64258 12.6667 7.64258Z",
    stroke: "#999999",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66602 7.64258V4.8635C4.66602 3.94218 5.01721 3.05859 5.64233 2.40712C6.26745 1.75564 7.11529 1.38965 7.99935 1.38965C8.8834 1.38965 9.73125 1.75564 10.3564 2.40712C10.9815 3.05859 11.3327 3.94218 11.3327 4.8635V7.64258",
    stroke: "#999999",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.52187b298d4c7651da50adafdcbcd7dc.svg";
export { ForwardRef as ReactComponent };